module.exports = __webpack_public_path__ + "static/media/YF98_3.8063ee44.jpg";